import { FC, useContext, useEffect, useMemo, useState } from "react";
import { PageHeader } from "../../../shared/components/MainLayout/components";
import { ColSize, InputFactory, RowSize } from "../../../shared/components";
import { AlertComponent } from "../../../shared/components/AlertComponent";
import { InfoContext, UIContext } from "../../../shared/contexts";
import CurrentAccountService from "../../../shared/services/currentAccount";
import { InputFactoryProp, Intermediary } from "../../../shared/interfaces";
import userHelper from "../../../shared/utils/userHelper";
import { Form } from "antd";
import { GetClientBalanceListServiceResponse } from "../../../shared/interfaces/services/client-balance";
import { ClientBalanceCard } from "./components/ClientBalanceCard";
import AuthenticationService from "../../../shared/services/authentication";

interface BalanceDetailProps {
    title: string;
}

export const BalanceDetail: FC<BalanceDetailProps> = ({ title }) => {

    const { setShowError } = useContext(UIContext);
    const { setTitle } = useContext(InfoContext);
    const [showErrorBalance, setShowErrorBalance] = useState(false);
    const [clientBalance, setClientBalance] = useState<GetClientBalanceListServiceResponse>({});
    const [form] = Form.useForm()
    const [producersInfo, setProducersInfo] = useState<Array<Intermediary>>();
    const [selectedProducer, setSelectedProducer] = useState<Intermediary>();
    const userInfo = userHelper.getUser();
    const [producersCombo, setProducersCombo] = useState<any>([]);
    const [isLoadingFilters, setIsLoadingFilters] = useState(false);

    const getComboProducer = async () => {
        try {
            const response = await AuthenticationService.getIntermediariesByIntermediary();
            setProducersInfo(response.data.intermediarios.intermediario);
            let comboProducersData = response.data.intermediarios.intermediario.map((producer: any) => ({
                value: producer.codigoInter,
                label: `${producer.nombreInter} (${producer.nivelInter}-${producer.codigoInter})`,
            }));

            if (response.status === 200) {
                setProducersCombo(comboProducersData);
            }
        } catch (error) { }
    };

    const getClientBalance = async () => {

        if (!producersInfo) return;

        let selectedProducerOption: Intermediary | undefined;

        setShowError(false);
        const filters = form.getFieldsValue();
        try {
            if (producersInfo) {
                selectedProducerOption = producersInfo.find(
                    (producer) => producer.codigoInter === filters.producer
                );
                setSelectedProducer(selectedProducerOption);
            }
            if (filters.producer !== selectedProducer?.codigoInter) {
                setShowErrorBalance(false);
                const responseClientBalance = await CurrentAccountService.getClientBalance(selectedProducerOption);
                if (responseClientBalance.saldo) {
                    setClientBalance({ ...responseClientBalance });
                }
            }
        } catch (error) {
            setShowErrorBalance(true);
        }
    };

    const getDetailForm = async () => {
        try {
            await getComboProducer();
            setIsLoadingFilters(false);
        } catch (error) { }
    };

    useEffect(() => {
        getDetailForm();
        /* eslint-disable-next-line */
    }, []);

    useEffect(() => {
        setTitle(title);
        /* eslint-disable-next-line */
    }, [title]);

    useEffect(() => {
        getClientBalance();
    }, [producersInfo]);

    const initialStateFilters = useMemo(() => ({
        producer: userInfo?.intermediarioSecundario?.codigoInter,
        date: clientBalance.saldo?.fechaSaldo,
    }), []);

    const inputsFilter: InputFactoryProp[] = [
        {
            element: 'select',
            placeHolder: 'Productor',
            items: producersCombo,
            allowClear: false,
            name: 'producer',
            label: 'Productor',
        },
        {
            element: 'input',
            name: 'date',
            type: 'text',
            value: clientBalance.saldo?.fechaSaldo,
            allowClear: false,
            label: 'Saldo Al',
            disabled: true,
        },
    ];

    useEffect(() => {
        if (clientBalance.saldo?.fechaSaldo) {
            form.setFieldsValue({
                date: clientBalance.saldo.fechaSaldo
            });
        }
    }, [clientBalance, form]);

    return (
        <div className="withholding-list">
            <PageHeader actions={undefined} />
            <RowSize rowProps={{ gutter: [0, 0] }} className="withholding-list__filter-row">
                <InputFactory
                    form={form}
                    items={inputsFilter}
                    onFilter={getClientBalance}
                    isLoading={isLoadingFilters}
                    initialState={initialStateFilters}
                />
            </RowSize>
            {
                showErrorBalance
                    ? <ColSize size={100}>
                        <AlertComponent message="Error al cargar" description="Hubo un error al tratar de cargar el balance del cliente, por favor intentelo de nuevo más tarde" type="error" />
                    </ColSize>
                    : (
                        <RowSize rowProps={{ gutter: [15, 15], className: "withholding-list__card-margin-fix", }}>
                            <ColSize size={100}>
                                {
                                    <ClientBalanceCard
                                        key={`ClientBalanceCard`}
                                        clientBalance={clientBalance.saldo! || {}}
                                        selectedProducer={selectedProducer}
                                    />
                                }
                            </ColSize>
                        </RowSize>
                    )
            }
        </div>
    )
}